import React from 'react'
import "./ChooseUs.css"
import { GiCheckMark } from "react-icons/gi";

const ChooseUs = () => {
    return (
        <div className='ChooseUs'>
            <div className='ChooseUs-main'>
                <div className='ChooseUs-box'>
                    <div className="choose-left">
                        <h4>About Pukhya Private Limited</h4>
                        {/* <h2>Pukhya for Superior sports science, Research ,and healthcare solutions</h2> */}
                        <h2>Advanced Medical Equipment for Sports Science & Research</h2>
                        <div className="choose-card">

                            <div className="choose-card-body">
                                <h6 style={{ color: "#ffff" }}>Welcome to Pukhya Private Limited Advanced Medical Equipment for Sports Science & Research
                                </h6>

                                <p>Pukhya Pvt Ltd is a leading distributor of state-of-the-art medical equipment across India, backed by a robust nationwide marketing network. Headquartered in Delhi, with a regional presence in Bangalore, we serve clients across the southern region and beyond. Our commitment is simple: build trust, nurture lasting relationships, and empower institutions with the tools they need to advance sports science, rehabilitation, and performance research.
                                </p>
                                <ul style={{ color: "#ffff" }}>

                                    <li>Cutting-Edge Technology: Precision instruments and medical devices that elevate research quality and clinical outcomes.
                                    </li>
                                    <li>Market Presence, Nationwide Reach: A strong distribution footprint spanning India, ensuring timely access to the latest innovations.
                                    </li>
                                    <li>Trusted Partnerships: Collaborations with Universities, Research Institutes, Hospitals, and Related Industries.
                                    </li>
                                </ul>
                            </div>

                            {/* 
                          <div className="choose-card">
                        
                            <div className="choose-card-body">
                               
                                <p>Pukhya Pvt Ltd is a leading distributor of state-of-the-art medical equipment across India, with a strong marketing network that spans the entire country. Our head office is located in Delhi, and we have a regional office in Bangalore to cater to our clients' needs across the southern region. At Pukhya, we are committed to fostering trust and maintaining long-lasting relationships with our valued customers, which include esteemed organizations such as DRDO, ISRO, universities, research institutions, hospitals, and related industries.</p>
                          
                            </div> */}
                            <h7 style={{ color: "#fff" }}>"What We Believe At Pukhya, we bring cutting-edge medical technology and precision instruments to the world of sports science, rehabilitation, and performance research. Our solutions are designed to help researchers and clinicians push the boundaries of performance, recovery, and longevity."</h7>
                        </div>
                        {/* <div className="choose-card">
                            <div className="choose-card-head">
                                <p><GiCheckMark /></p>
                                <h5>Expert Collaborations</h5>
                            </div>
                            <div className="choose-card-body">
                                <p>Partnering with leading sports science , research equipment and healthcare leading manufacturers.</p>
                            </div>
                        </div>
                        <div className="choose-card">
                            <div className="choose-card-head">
                                <p><GiCheckMark /></p>
                                <h5>Innovative Technology</h5>
                            </div>
                            <div className="choose-card-body">
                                <p>We leverage cutting-edge technology to develop practical, user-friendly systems that enhance sports science , research and healthcare solutions.</p>
                            </div>
                        </div>
                        <div className="choose-card">
                            <div className="choose-card-head">
                                <p><GiCheckMark /></p>
                                <h5>Commitment to Excellence</h5>
                            </div>
                            <div className="choose-card-body">
                                <p>Our unwavering dedication to quality and continuous improvement drives us to provide the best possible solutions for our customers.</p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChooseUs
